import React, { useCallback } from 'react';

import { BP_LEVEL, AFFILIATE_LEVEL } from '../constants';
import AffiliatesField from './AffiliatesField';

export function hasAffiliates({ invoiceLevel, ios }) {
  return (invoiceLevel === BP_LEVEL && ios) || invoiceLevel === AFFILIATE_LEVEL;
}

export default ({ invoiceLevel, ios, disabled = false }) => {
  const handleValidate = useCallback(
    (value) => {
      if (!value) {
        return 'Affiliate is required';
      }
    },
    [invoiceLevel]
  );

  return (
    <React.Fragment>
      {invoiceLevel === BP_LEVEL && ios ? (
        <AffiliatesField
          label={'Affiliates for the new IO'}
          disabled={disabled}
        />
      ) : invoiceLevel === AFFILIATE_LEVEL ? (
        <AffiliatesField
          validate={handleValidate}
          disabled={disabled}
          label={'Affiliates'}
          required={true}
        />
      ) : null}
    </React.Fragment>
  );
};
